export function Cell({rowspan, children}) {
  return <div class="cell" style={`--rowspan: ${rowspan}`}>
    {children}
  </div>;
}
